import React from 'react';
import { Router } from './routes';
import './styles/global.scss';

const App = () => {
  return <Router />;
};

export default App;
